import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';

import ClientOrderPortalRoutes from './Routers/appRouter';

import './assets/css/style.scss';

const App = () => {
  return <ClientOrderPortalRoutes />;
};

export default App;
